import { render, staticRenderFns } from "./SlugBase.vue?vue&type=template&id=e9b3a4e8&scoped=true"
import script from "./SlugBase.vue?vue&type=script&lang=js"
export * from "./SlugBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b3a4e8",
  null
  
)

export default component.exports